import type { SummitGalleryDay, SummitGalleryPhoto } from "@/components/home/summit-gallery-data";

export const SUMMIT_HERO_INTERVAL_MS = 6 * 60 * 60 * 1000;

export const getSummitHeroBucket = (now = Date.now()) =>
  Math.floor(now / SUMMIT_HERO_INTERVAL_MS);

const shuffle = <T>(items: T[], seed: number) => {
  const result = [...items];
  let value = seed || 1;

  for (let index = result.length - 1; index > 0; index -= 1) {
    value = (value * 1664525 + 1013904223) >>> 0;
    const swapIndex = value % (index + 1);
    [result[index], result[swapIndex]] = [result[swapIndex], result[index]];
  }

  return result;
};

export const selectSummitHeroPhotoSets = (
  days: SummitGalleryDay[],
  bucket: number,
  setCount = 3,
  count = 7,
): SummitGalleryPhoto[][] => {
  const availableDays = shuffle(days.filter((day) => day.photos.length), bucket);
  const used = new Set<string>();
  const sets = Array.from({ length: setCount }, () => [] as SummitGalleryPhoto[]);

  sets.forEach((set, setIndex) => {
    availableDays.slice(0, count).forEach((day) => {
      const photo = shuffle(day.photos, bucket + day.id * 31 + setIndex)
        .find(({ src }) => !used.has(src));
      if (photo) {
        set.push(photo);
        used.add(photo.src);
      }
    });
  });

  const remaining = shuffle(
    availableDays.flatMap((day) => day.photos),
    bucket * 31,
  ).filter(({ src }) => !used.has(src));

  sets.forEach((set) => {
    while (set.length < count && remaining.length) {
      set.push(remaining.shift()!);
    }
  });

  return sets;
};
